import React from 'react'

export function TrueFalseAnswerForm({ q, answer, onChange }) {
  const statements = Array.isArray(q.payload?.statements) ? q.payload.statements : []
  const answerStatements = Array.isArray(answer?.statements) ? answer.statements : []

  // Backward compatibility: legacy single boolean answer
  const legacyVal =
    !statements.length && typeof answer?.value === 'boolean' ? answer.value : null

  if (!statements.length) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={legacyVal === true}
            onChange={() => onChange(q, { value: true })}
          />
          <span>صحيح</span>
        </label>
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={legacyVal === false}
            onChange={() => onChange(q, { value: false })}
          />
          <span>خطأ</span>
        </label>
      </div>
    )
  }

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      {statements.map((s, idx) => {
        const current = answerStatements[idx] || {}
        const val = typeof current.value === 'boolean' ? current.value : null

        return (
          <div key={idx} style={{ display: 'grid', gap: 4 }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
              <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{idx + 1}-</div>
              <div style={{ fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
                {s?.text || ''}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
              <label style={{ display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  checked={val === true}
                  onChange={() => {
                    const next = [...answerStatements]
                    next[idx] = { ...(next[idx] || {}), value: true }
                    onChange(q, { statements: next })
                  }}
                />
                <span>صحيح</span>
              </label>

              <label style={{ display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  checked={val === false}
                  onChange={() => {
                    const next = [...answerStatements]
                    next[idx] = { ...(next[idx] || {}), value: false }
                    onChange(q, { statements: next })
                  }}
                />
                <span>خطأ</span>
              </label>
            </div>
          </div>
        )
      })}
    </div>
  )
}
